import React from 'react'

const Divider = props => {

    return<div style={{
        border:"solid .5px #d8d8d8",
        padding: 0,
        width:"100%",
        opacity:"0.5",
        ...props.style
    }}/>
}
export default Divider;